import { Area } from '@ff-os/shared-utils/types/Area';
import { areSameOrientation } from './areSameOrientation';
import { PhotoPrintsJson } from './PhotoPrintsJson';

/**
 * Calculate the aspect ratio for photo cropping, taking into account:
 * 1. Crop override from scene size options (border-aspect-ratio) - only when borders are applied
 * 2. PhotoFun border adjustments
 * 3. Default size-based aspect ratio
 */
export const getCropAspectRatio = (
    size: PhotoPrintsJson.Size,
    photo: { crop: Area; width: number; height: number },
    hasBorder?: boolean
): number => {
    const hasCropOverride = size.borderAspectRatio;
    const hasBorderApplied = hasBorder;

    let aspectRatio = areSameOrientation(size, photo.crop)
        ? size.width / size.height
        : size.height / size.width;

    // Use crop override from scene size options only when a border is applied
    if (hasCropOverride && hasBorderApplied) {
        const [widthStr, heightStr] = hasCropOverride.split('/');
        const overrideWidth = parseFloat(widthStr);
        const overrideHeight = parseFloat(heightStr);

        if (!isNaN(overrideWidth) && !isNaN(overrideHeight) && overrideHeight !== 0) {
            // Use the borderAspectRatio directly without orientation switching
            aspectRatio = overrideWidth / overrideHeight;
        }
    }

    return aspectRatio;
};